const PredictiveIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15964_89123)">
      <path
        d="M27.3086 21.0938H22.5039C22.0188 21.0938 21.625 21.4875 21.625 21.9727V26.4844H28.1875V21.9727C28.1875 21.4875 27.7937 21.0938 27.3086 21.0938Z"
        fill="white"
      />
      <path
        d="M7.49609 16.97H2.69141C2.20625 16.97 1.8125 17.3637 1.8125 17.8489V26.4844H8.375V17.8489C8.375 17.3637 7.98125 16.97 7.49609 16.97Z"
        fill="white"
      />
      <path
        d="M17.4023 10.6055H12.5977C12.1125 10.6055 11.7188 10.9992 11.7188 11.4844V26.4844H18.2812V11.4844C18.2812 10.9992 17.8875 10.6055 17.4023 10.6055Z"
        fill="white"
      />
      <path
        d="M29.1211 28.2422H0.878906C0.39375 28.2422 0 28.6359 0 29.1211C0 29.6062 0.39375 30 0.878906 30H29.1211C29.6063 30 30 29.6062 30 29.1211C30 28.6359 29.6063 28.2422 29.1211 28.2422Z"
        fill="white"
      />
      <path
        d="M11.8215 8.78906H18.1848C18.6371 8.78906 18.9875 8.39473 18.9377 7.94473C18.9365 7.93301 18.9353 7.92129 18.9336 7.91016C18.824 6.92109 18.3506 6.04219 17.6498 5.41055C16.949 4.77891 16.0209 4.39453 15.0031 4.39453H15.0025C12.9547 4.39512 11.2707 5.95078 11.068 7.94531C11.068 7.94766 11.0674 7.95 11.0674 7.95234C11.0164 8.39883 11.3715 8.78906 11.8215 8.78906Z"
        fill="white"
      />
      <path
        d="M15.002 4.39453C16.2155 4.39453 17.1992 3.41078 17.1992 2.19727C17.1992 0.983749 16.2155 0 15.002 0C13.7884 0 12.8047 0.983749 12.8047 2.19727C12.8047 3.41078 13.7884 4.39453 15.002 4.39453Z"
        fill="white"
      />
      <path
        d="M1.91523 15.2122H8.27851C8.73086 15.2122 9.08125 14.8178 9.03144 14.3678C9.03027 14.3561 9.0291 14.3444 9.02734 14.3333C8.91777 13.3442 8.44433 12.4653 7.74355 11.8336C7.04277 11.202 6.11465 10.8176 5.09687 10.8176H5.09629C3.04843 10.8182 1.36445 12.3739 1.16172 14.3684C1.16172 14.3708 1.16113 14.3731 1.16113 14.3754C1.11015 14.8219 1.46523 15.2122 1.91523 15.2122Z"
        fill="white"
      />
      <path
        d="M5.0957 10.8176C6.30922 10.8176 7.29297 9.83388 7.29297 8.62036C7.29297 7.40684 6.30922 6.4231 5.0957 6.4231C3.88219 6.4231 2.89844 7.40684 2.89844 8.62036C2.89844 9.83388 3.88219 10.8176 5.0957 10.8176Z"
        fill="white"
      />
      <path
        d="M21.7199 19.3137H28.0832C28.5355 19.3137 28.8859 18.9194 28.8361 18.4694C28.835 18.4577 28.8338 18.4459 28.832 18.4348C28.7225 17.4458 28.249 16.5668 27.5482 15.9352C26.8475 15.3036 25.9193 14.9192 24.9016 14.9192H24.901C22.8531 14.9198 21.1691 16.4754 20.9664 18.47C20.9664 18.4723 20.9658 18.4747 20.9658 18.477C20.9148 18.9235 21.2699 19.3137 21.7199 19.3137Z"
        fill="white"
      />
      <path
        d="M24.9004 14.9192C26.1139 14.9192 27.0977 13.9354 27.0977 12.7219C27.0977 11.5084 26.1139 10.5247 24.9004 10.5247C23.6869 10.5247 22.7031 11.5084 22.7031 12.7219C22.7031 13.9354 23.6869 14.9192 24.9004 14.9192Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15964_89123">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default PredictiveIcon
